import {
  type OperationResponse,
  type Parameters,
  type UnknownParamsObject,
} from "../../common.ts";
import { omitPathParameters, replacePathParameters } from "../../utils";
import type { AxiosInstance, AxiosRequestConfig } from "axios";
import type * as Paths from "./paths";

interface OperationMethods {
  "setUserData"(
    parameters?: Parameters<UnknownParamsObject> | null,
    data?: Paths.SetUserData.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.SetUserData.Responses.$200>;
  "setManyUserData"(
    parameters?: Parameters<UnknownParamsObject> | null,
    data?: Paths.SetManyUserData.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.SetManyUserData.Responses.$200>;
  "flushUserData"(
    parameters?: Parameters<UnknownParamsObject> | null,
    data?: Paths.SetManyUserData.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.FlushUserData.Responses.$200>;
}

export const getUserDataOperations = (client: AxiosInstance) => {
  const setUserData: OperationMethods["setUserData"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/user-data/set";
    return client.post(replacePathParameters(url, parameters), data, {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };
  const setManyUserData: OperationMethods["setManyUserData"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/user-data/setMany";
    return client.post(replacePathParameters(url, parameters), data, {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };
  const flushUserData: OperationMethods["flushUserData"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/user-data/flush";
    return client.post(replacePathParameters(url, parameters), data, {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };

  return {
    setUserData,
    setManyUserData,
    flushUserData,
  };
};
